import { doLogout } from "actions/authAction";
import {
  BASE_URL,
  USER_URL,
  REGULATOR_URL,
  USER_GET_ERROR,
  USER_GET_LOADING,
  USER_GET_SUCCESS,
  USER_VIEW_ERROR,
  USER_VIEW_LOADING,
  USER_VIEW_SUCCESS,
  USER_ADD_ERROR,
  USER_ADD_LOADING,
  USER_ADD_SUCCESS,
  USER_DELETE_ERROR,
  USER_DELETE_LOADING,
  USER_DELETE_SUCCESS,
  USER_OPERATOR_PUSAT_ERROR,
  USER_OPERATOR_PUSAT_LOADING,
  USER_OPERATOR_PUSAT_SUCCESS,
  USER_OPERATOR_PUSAT_URL,
  USER_PELINDO_ERROR,
  USER_PELINDO_LOADING,
  USER_PELINDO_SUCCESS,
  USER_PELINDO_URL,
  USER_UPT_ERROR,
  USER_UPT_LOADING,
  USER_UPT_SUCCESS,
  USER_UPT_URL,
} from "./constant";

const userPelindoError = (bool) => {
  return {
    type: USER_PELINDO_ERROR,
    userPelindoError: bool,
  };
};

const userPelindoLoading = (bool) => {
  return {
    type: USER_PELINDO_LOADING,
    userPelindoLoading: bool,
  };
};

const userPelindoSuccess = (bool, userPelindo) => {
  return {
    type: USER_PELINDO_SUCCESS,
    userPelindoSuccess: bool,
    userPelindo,
  };
};
const userUptError = (bool) => {
  return {
    type: USER_UPT_ERROR,
    userUptError: bool,
  };
};

const userUptLoading = (bool) => {
  return {
    type: USER_UPT_LOADING,
    userUptLoading: bool,
  };
};

const userUptSuccess = (bool, userUpt) => {
  return {
    type: USER_UPT_SUCCESS,
    userUptSuccess: bool,
    userUpt,
  };
};

const userOperatorPusatError = (bool) => {
  return {
    type: USER_OPERATOR_PUSAT_ERROR,
    userOperatorPusatError: bool,
  };
};

const userOperatorPusatLoading = (bool) => {
  return {
    type: USER_OPERATOR_PUSAT_LOADING,
    userOperatorPusatLoading: bool,
  };
};

const userOperatorPusatSuccess = (bool, userOperatorPusat) => {
  return {
    type: USER_OPERATOR_PUSAT_SUCCESS,
    userOperatorPusatSuccess: bool,
    userOperatorPusat,
  };
};

const userGetError = (bool) => {
  return {
    type: USER_GET_ERROR,
    userGetError: bool,
  };
};

const userGetLoading = (bool) => {
  return {
    type: USER_GET_LOADING,
    userGetLoading: bool,
  };
};

const userGetSuccess = (bool, users) => {
  return {
    type: USER_GET_SUCCESS,
    userGetSuccess: bool,
    users,
  };
};

const userViewError = (bool) => {
  return {
    type: USER_VIEW_ERROR,
    userViewError: bool,
  };
};

const userViewLoading = (bool) => {
  return {
    type: USER_VIEW_LOADING,
    userViewLoading: bool,
  };
};

const userViewSuccess = (bool, user) => {
  return {
    type: USER_VIEW_SUCCESS,
    userViewSuccess: bool,
    user,
  };
};

const userAddError = (bool) => {
  return {
    type: USER_ADD_ERROR,
    userAddError: bool,
  };
};

const userAddLoading = (bool) => {
  return {
    type: USER_ADD_LOADING,
    userAddLoading: bool,
  };
};

const userAddSuccess = (bool, user) => {
  return {
    type: USER_ADD_SUCCESS,
    userAddSuccess: bool,
    user,
  };
};

const userDeleteError = (bool) => {
  return {
    type: USER_DELETE_ERROR,
    userDeleteError: bool,
  };
};

const userDeleteLoading = (bool) => {
  return {
    type: USER_DELETE_LOADING,
    userDeleteLoading: bool,
  };
};

const userDeleteSuccess = (bool, user) => {
  return {
    type: USER_DELETE_SUCCESS,
    userDeleteSuccess: bool,
    user,
  };
};

export function userDishubFetchAll() {
  return (dispatch) => {
    dispatch(userGetSuccess(false, null));
    dispatch(userGetError(false));
    dispatch(userGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "pelabuhan/list-users-dishub", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        // dispatch(userGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userGetLoading(false));
        dispatch(userGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userGetError(true));
        dispatch(userGetLoading(false));
      });
  };
}

export function userPelindoFetchAll() {
  return (dispatch) => {
    dispatch(userPelindoSuccess(false, null));
    dispatch(userPelindoError(false));
    dispatch(userPelindoLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_PELINDO_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userPelindoLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userPelindoSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userPelindoError(true));
      });
  };
}

export function userUptFetchAll() {
  return (dispatch) => {
    dispatch(userUptSuccess(false, null));
    dispatch(userUptError(false));
    dispatch(userUptLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_UPT_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userUptLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userUptSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userUptError(true));
      });
  };
}

export function userOperatorPusatFetchAll() {
  return (dispatch) => {
    dispatch(userOperatorPusatSuccess(false, null));
    dispatch(userOperatorPusatError(false));
    dispatch(userOperatorPusatLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_OPERATOR_PUSAT_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userOperatorPusatLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userOperatorPusatSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userOperatorPusatError(true));
      });
  };
}

export function userFetchAll() {
  return (dispatch) => {
    dispatch(userGetSuccess(false, null));
    dispatch(userGetError(false));
    dispatch(userGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + REGULATOR_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userGetError(true));
      });
  };
}

export function userAll(data) {
  return (dispatch) => {
    dispatch(userGetSuccess(false, null));
    dispatch(userGetError(false));
    dispatch(userGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "users", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        // dispatch(userGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userGetLoading(false));
        dispatch(userGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userGetError(true));
        dispatch(userGetLoading(false));
      });
  };
}

export function userFetchSub(company_id) {
  return (dispatch) => {
    dispatch(userGetSuccess(false, null));
    dispatch(userGetError(false));
    dispatch(userGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ company: company_id }),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userGetError(true));
      });
  };
}

export function userFetchPage(item) {
  return (dispatch) => {
    dispatch(userGetSuccess(false, null));
    dispatch(userGetError(false));
    dispatch(userGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userGetError(true));
      });
  };
}

export function userAdd(data) {
  return (dispatch) => {
    dispatch(userAddError(false));
    dispatch(userAddSuccess(false, null));
    dispatch(userAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + REGULATOR_URL + "/new", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((user) => {
        dispatch(userAddSuccess(true, user));
      })
      .catch((err) => {
        dispatch(userAddError(true));
      });
  };
}

export function userChangePassword(data) {
  return (dispatch) => {
    dispatch(userAddError(false));
    dispatch(userAddSuccess(false, null));
    dispatch(userAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL + "/change_password", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((user) => {
        dispatch(userAddSuccess(true, user));
      })
      .catch((err) => {
        dispatch(userAddError(true));
      });
  };
}

export function userResetPassword(data) {
  return (dispatch) => {
    dispatch(userAddError(false));
    dispatch(userAddSuccess(false, null));
    dispatch(userAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL + "/reset_password", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((user) => {
        dispatch(userAddSuccess(true, user));
      })
      .catch((err) => {
        dispatch(userAddError(true));
      });
  };
}

export function userFetchOne(id) {
  return (dispatch) => {
    dispatch(userViewError(false));
    dispatch(userViewSuccess(false, null));
    dispatch(userViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL + "/" + id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userViewError(true));
      });
  };
}

export function userFetchUser(id) {
  return (dispatch) => {
    dispatch(userViewError(false));
    dispatch(userViewSuccess(false, null));
    dispatch(userViewLoading(true));
    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
      }),
    };
    fetch(BASE_URL + REGULATOR_URL + "/profile", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userViewError(true));
      });
  };
}

export function userUpdate(data) {
  return (dispatch) => {
    dispatch(userAddError(false));
    dispatch(userAddSuccess(false, null));
    dispatch(userAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + REGULATOR_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((user) => {
        if (user.success) {
          dispatch(userAddSuccess(true, user));
        } else {
          dispatch(userAddError(true));
        }
      })
      .catch((err) => {
        dispatch(userAddError(true));
      });
  };
}

export function handleStatus(data) {
  return (dispatch) => {
    dispatch(userAddError(false));
    dispatch(userAddSuccess(false, null));
    dispatch(userAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: data.id }),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "user/" + data.status, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((user) => {
        dispatch(userAddSuccess(true, user));
      })
      .catch((err) => {
        dispatch(userAddError(true));
      });
  };
}

export function userDelete(id) {
  return (dispatch) => {
    dispatch(userViewSuccess(false, null));
    dispatch(userDeleteError(false));
    dispatch(userDeleteSuccess(false, null));
    dispatch(userDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: id }),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + USER_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(userDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(userDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(userDeleteError(true));
      });
  };
}
